import { CommonModule } from "@angular/common";
import { Component, computed, inject } from "@angular/core";
import { AbcTabPanelComponent } from "@barthauer/abc/ui-components";
import { SharedModule } from "../../../../shared/shared.module";
import { MeasureService } from "../../measure.service";
import { CommentsPopupComponent } from "../../../../shared/comment/comments-popup/comments-popup.component";
import { DocumentComponent } from "../../../../shared/document/document.component";
import { DocumentService } from "../../../../shared/document/document.service";
import { DataService } from "../../../../services/data.service";
import { MeasureChangeHistoryComponent } from "../measure-change-history/measure-change-history.component";

@Component({
  selector: 'ubt-geods-tab-panel',
  templateUrl: './tab-panel.component.html',
  styleUrls: ['./tab-panel.component.scss'],
  imports: [
    AbcTabPanelComponent,
    CommonModule,
    SharedModule,
    CommentsPopupComponent,
    DocumentComponent,
    MeasureChangeHistoryComponent
  ]
})
export class TabPanelComponent {
  private readonly measureService= inject(MeasureService);
  private readonly documentService= inject(DocumentService);
  private readonly dataService= inject(DataService);
  
  private res: (key: string, ...value: string[]) => string = this.dataService.res;

  protected measureId = computed(()=>this.measureService.currentMeasureId());
  protected selectedIndex=0;
  protected tabItems = computed(()=>[
    {
      index:0,
      title: this.res('Ubt-Measure-Detail-Comments')
    },
    {
      index:1,
      title:`${this.res('Ubt-TreeList-Documents')} (${this.documentService.documentsNumber()})`
    },
    {
      index:2,
      title:this.res('Ubt-Measure-Detail-System-Logs')
    }
  ]);
}
